import { List, Record } from 'immutable'
import { AssociatedContact, IAssociatedContact } from './AssociatedContact'

export interface ITransactionHistory {
  readonly id: string
  readonly owners: List<IAssociatedContact>
  readonly saleDate: number
  readonly salePrice: number
}

const TransactionHistoryRecord = Record({
  id: '',
  owners: List<AssociatedContact>(),
  saleDate: 0,
  salePrice: 0,
})

export class TransactionHistory extends TransactionHistoryRecord
  implements ITransactionHistory {
  public static fromJS(initialState?: any) {
    if (!initialState) {
      return new TransactionHistory()
    }

    const { owners, ...rest } = initialState

    return new TransactionHistory({
      owners: Array.isArray(owners)
        ? List(
            owners.map((o: IAssociatedContact) => AssociatedContact.fromJS(o)),
          )
        : List<AssociatedContact>(),
      ...rest,
    })
  }

  public readonly id: string
  public readonly owners: List<AssociatedContact>
  public readonly saleDate: number
  public readonly salePrice: number

  constructor(props?: Partial<TransactionHistory>) {
    props ? super(props) : super()
  }
}
